import { IRoomEditorDrawingState } from "../components/drawing/editor/FloorplanEditor";
import { IFloorplan } from "../types/SiteLocation.types";
import apiFetch from './index';

/** Saves an edit to the floorplan metadata, effectively allows users to rename a floorplan */
export async function editFloorplanMetadata(floorplan: IFloorplan) {
    if (floorplan.Id !== undefined && floorplan.Id.trim() !== "") {
        return await apiFetch(`/api/floorplans/${floorplan.Id}`, {
            method: 'POST',
            body: JSON.stringify(floorplan),
            headers: {
                Accept: 'application/json',
                'Content-Type' : 'application/json'
            },
            credentials: 'include'
        });
    } else {
        return new Error("Unable to update floorplan metadata: Id is invalid");
    }
}

/** Creates a new, blank floorplan for a given location */
export async function createNewFloorplan(locationId: number) {
    return await apiFetch(`/api/floorplans/location/${locationId}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

/** Deletes a floorplan from the system */
export async function deleteFloorplan(floorplanId: string) {
    return await apiFetch(`/api/floorplans/${floorplanId}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

/** Loads the lastest floorplan layout edit */
export async function loadLatestFloorplanEdit(floorplanId: string) {
    return await apiFetch(`/api/floorplans/${floorplanId}/layout/latest`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

/** Loads the latest published floorplan layout */
export async function loadLatestPublishedFloorplan(floorplanId: string) {
    return await apiFetch(`/api/floorplans/${floorplanId}/layout`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

/** Loads floorplans for a given location */
export async function loadFloorplansForLocation(locationId: number) {
    return await apiFetch(`/api/floorplans/location/${locationId}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

// POST floorplan/{floorplanGuid}/layout - new blank layout
export async function newFloorplanLayoutFromBlank(floorplanId: string) {
    return await apiFetch(`/api/floorplans/${floorplanId}/newlayout`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

// POST floorplan/{floorplanGuid}/layout/fromPrevious 
export async function newFloorplanLayoutFromPrevious(floorplanId: string) {
    return await apiFetch(`/api/floorplans/${floorplanId}/newlayout/fromPrevious`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

// floorplan/{floorplanGuid}/layout/{id} - updates a floorplan layout
export async function updateFloorplanLayout(floorplanId: string, layoutId: number, drawing: IRoomEditorDrawingState) {
    return await apiFetch(`/api/floorplans/${floorplanId}/layout/${layoutId}`, {
        method: 'POST',
        body: JSON.stringify(drawing),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
}

// floorplan/{floorplanGuid}/layout/{id}/publish - publishes a draft floorplan layout
export async function publishFloorplanLayout(floorplanId: string, layoutId: number, drawing: IRoomEditorDrawingState) {
    return await apiFetch(`/api/floorplans/${floorplanId}/layout/${layoutId}/publish`, {
        method: 'POST',
        body: JSON.stringify(drawing),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
}
